import { HHTypography } from '@hinge-health/react-component-library';
import InsertDriveFileRounded from '@mui/icons-material/InsertDriveFileRounded';
import Stack from '@mui/material/Stack';
import { ContractTemplateType, ContractType } from '../../types';
import { IDiscount } from '../../utils/discount-utils';
import ContractDetailView from './contract-view-components/contract-detail-view';

interface ActiveContractDetailsProps {
  clientInsurerName: string;
  templates: ContractTemplateType[];
  contract?: ContractType;
  discounts?: IDiscount[];
}

const ActiveContractDetails = ({
  clientInsurerName,
  templates,
  contract,
  discounts,
}: ActiveContractDetailsProps): JSX.Element => {
  if (!contract) {
    return (
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: '200px',
          fontSize: '3.5rem',
          borderRadius: '5px',
        }}
      >
        <InsertDriveFileRounded color="disabled" fontSize="inherit" />
        <HHTypography hhVariant="body">
          {`No active contracts for ${clientInsurerName}`}
        </HHTypography>
      </Stack>
    );
  }

  return (
    <ContractDetailView
      contract={contract}
      templates={templates}
      discounts={discounts}
    />
  );
};

export default ActiveContractDetails;
